import { render, staticRenderFns } from "./GatDateEdit.vue?vue&type=template&id=c5f24ca2&scoped=true"
import script from "./GatDateEdit.vue?vue&type=script&lang=js"
export * from "./GatDateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f24ca2",
  null
  
)

export default component.exports